import type { GetStyles, ZIndexStyledProps } from '@sds-system/types';

export const getZIndexStyles: GetStyles<ZIndexStyledProps> = ({ zIndex }) => {
  return {
    zIndex,
  };
};
